var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stepper-step',{staticClass:"disable-ripple",attrs:{"editable":"","complete":_vm.completed,"edit-icon":_vm.icon,"complete-icon":_vm.icon,"color":_vm.color,"step":_vm.question.id}})}
var staticRenderFns = []

export { render, staticRenderFns }